import { useTranslation } from "react-i18next";
export default function FooterPage() {
  const { t, i18n } = useTranslation();

  const footerLinks = [
    { 
      label: "AGB's", 
      href: i18n.language === "en" ? "/en/agbs" : "/agbs" 
    },
    { 
      label: "Impressum", 
      href: i18n.language === "en" ? "/en/impressum" : "/impressum" 
    },
    // { label: "FAQ's", href: `#faqs` },
  ];

  return (
    <footer className="w-full" style={{ background: "#036EA4" }}>
      <div
        className="max-w-[1728px] mx-auto"
        style={{
          padding: "40px 80px",
          display: "flex",
          flexDirection: "column",
          gap: "32px",
        }}
      >
        <div className="flex flex-col items-start justify-between gap-5 sm:flex-row sm:items-center">
          <div className="flex items-center gap-1.5 font-montserrat">
            <span className="text-xs font-medium text-white font-poppins">
              {/* {t("CH")} */}
              <span className="flex items-center justify-center w-7 h-7 rounded-sm overflow-hidden shrink-0">
                  <img src="/images/swiss_flag.png" alt="swiss_flag"/>
              </span>
            </span>
            <span className="text-xl font-bold tracking-wide text-white font-poppins">
              {t("SwissTaxFile")}
            </span>
          </div>

          <ul className="flex flex-wrap items-center gap-8 p-0 m-0 list-none">
            {footerLinks.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  className="font-medium no-underline transition-opacity duration-200 font-poppins text-[#FBBF24] hover:opacity-70"
                >
                  {t(link.label)}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div
          className="w-full h-px"
          style={{ background: "rgba(255,255,255,0.35)" }}
        />

        <p
          className="font-sans text-xs text-center"
          style={{ color: "rgba(255,255,255,0.75)" }}
        >
          {t("footerText")}{" "}
        </p>
      </div>

      <style>{`
        @media (max-width: 640px) {
          footer > div { padding: 32px 20px !important; }
        }
      `}</style>
    </footer>
  );
}